import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { CriteriLiquidatiRequest } from 'src/app/report/models/criteri-liquidati-request';
import { CriteriMensilizzazioniRequest } from 'src/app/report/models/criteri-mensilizzazioni-request';
import { EstrazioneDatiRequest } from '../../common/models/dto/estrazione-dati-request';
import { CriteriAccantonamentiRequest } from '../../report/models/criteri-accantonamenti-request';
import { CriteriAdempimentiRequest } from '../../report/models/criteri-adempimenti-request';
import { CriteriBilancioRequest } from '../../report/models/criteri-bilancio-request';
import { CriteriClassificazioniRequest } from '../../report/models/criteri-classificazioni-request';
import { CriteriEsitiRequest } from '../../report/models/criteri-esiti-request';
import { CriteriFattureRequest } from '../../report/models/criteri-fatture-request';
import { CriteriIncarichiRequest } from '../../report/models/criteri-incarichi-request';
import { CriteriIncassiRequest } from '../../report/models/criteri-incassi-request';
import { CriteriPagamentiRequest } from '../../report/models/criteri-pagamenti-request';
import { CriteriParcelleRequest } from '../../report/models/criteri-parcelle-request';
import { CriteriPerformanceRequest } from '../../report/models/criteri-performance-request';
import { CriteriStatoFascicoliRequest } from '../../report/models/criteri-stato-fascicoli-request';
import { CriteriStatoPraticheRequest } from '../../report/models/criteri-stato-pratiche-request';
import { FileListDownload } from '../../report/models/file-list-download';
import { ServicePathsSettings } from '../configuration/service-paths-settings';
import { FileListArchivio } from 'src/app/report/models/file-list-archivio';

@Injectable()
export class ReportService {

  fileListDownloadArr: FileListDownload[] = [];
  idFile: number = 0;
  isOpenWindowReport: boolean = false;

  constructor(private http: HttpClient, private httpBase: HttpClient) {
    this.http = http;
    this.httpBase = httpBase;
  }

  private handleError(error: Response | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const errMsg = error.json() || '';
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return throwError(errMsg);
  }

  /*
    getSintesiStatoPratiche(): Observable<any> {
      return this.http.get('../../../LocalJson/pratiche_sintesi.json').pipe(
        map((res => res.json())),
        catchError(this.handleError));
    }

    getSintesiStatoFascicoli(): Observable<any> {
      return this.http.get('../../../LocalJson/fascicoli_sintesi.json').pipe(
        map((res => res.json())),
        catchError(this.handleError));
    }

    getSintesiClassificazioni(): Observable<any> {
      return this.http.get('../../../LocalJson/classificazioni_sintesi.json').pipe(
        map((res => res.json())),
        catchError(this.handleError));
    }

    getSintesiEsiti(): Observable<any> {
      return this.http.get('../../../LocalJson/esiti_sintesi.json').pipe(
        map((res => res.json())),
        catchError(this.handleError));
    }*/

  getFileArchivio(): Observable<{filesData:FileListArchivio[]}> {
    return this.http.get<{filesData:FileListArchivio[]}>(ServicePathsSettings.DOMINIO_REPORT + ServicePathsSettings.REPORT_LISTA_FILE_ARCHIVIO);
  }

  getSintesiStatoPratiche(): Observable<any> {
    let url;
    let response = this.http.get(ServicePathsSettings.DOMINIO_REPORT + ServicePathsSettings.REPORT_PRATICHE_SINTESI)
    return response;
  }

  getAndamentoPratiche(): Observable<any> {
    let response = this.http.get(ServicePathsSettings.DOMINIO_REPORT + ServicePathsSettings.REPORT_PRATICHE_ANDAMENTO_PRATICHE)
    return response;
  }

  exportStatoPratiche(url: string, request: CriteriStatoPraticheRequest): Observable<any> {
    return this.http.post(ServicePathsSettings.DOMINIO_REPORT + url, request, {
      observe: 'response',
      responseType: 'blob' as 'json'
    });
  }

  getSintesiStatoFascicoli(): Observable<any> {
    let response = this.http.get(ServicePathsSettings.DOMINIO_REPORT + ServicePathsSettings.REPORT_FASCICOLI_SINTESI)
    return response;
  }

  exportStatoFascicoli(url: string, request: CriteriStatoFascicoliRequest): Observable<any> {
    console.log(request);
    let response = this.http.post<Blob>(ServicePathsSettings.DOMINIO_REPORT + url, request, {
      observe: 'response',
      responseType: 'blob' as 'json'
    })

    return response;
  }

  getSintesiEsiti(): Observable<any> {
    let response = this.http.get(ServicePathsSettings.DOMINIO_REPORT + ServicePathsSettings.REPORT_ESITI_SINTESI)
    return response;
  }

  getPerformanceLegali(): Observable<any> {
    return this.http.get(ServicePathsSettings.DOMINIO_REPORT + ServicePathsSettings.PERFORMANCE_PATH)
  }

  getAndamentoPetitum(): Observable<any> {

    let response = this.http.get(ServicePathsSettings.DOMINIO_REPORT + ServicePathsSettings.REPORT_PRATICHE_ANDAMENTO_PETITUM)
    return response;
  }


  exportEsiti(url: string, request: CriteriEsitiRequest): Observable<any> {
    console.log(request);
    let response = this.http.post<Blob>(ServicePathsSettings.DOMINIO_REPORT + url, request, {
      observe: 'response',
      responseType: 'blob' as 'json'
    })

    return response;
  }

  exportLiquidati(url: string, request: CriteriLiquidatiRequest): Observable<any> {
    console.log(request);
    let response = this.http.post<Blob>(ServicePathsSettings.DOMINIO_REPORT + url, request, {
      observe: 'response',
      responseType: 'blob' as 'json'
    })

    return response;
  }

  getSintesiClassificazioni(): Observable<any> {
    let response = this.http.get(ServicePathsSettings.DOMINIO_REPORT + ServicePathsSettings.REPORT_CLASSIFICAZIONI_SINTESI)
    return response;
  }

  getDownloadReport(idReport: string): Observable<any> {
    const url = ServicePathsSettings.DOMINIO_REPORT + ServicePathsSettings.REPORT_DOWNLOAD_FILE_ARCHIVIO;
    return this.http.get(url + idReport, {responseType: 'blob' as 'json'})
  }

  exportClassificazioni(url: string, request: CriteriClassificazioniRequest): Observable<any> {
    console.log(request);
    let response = this.http.post<Blob>(ServicePathsSettings.DOMINIO_REPORT + url, request, {
      observe: 'response',
      responseType: 'blob' as 'json'
    })

    return response;
  }

  exportMensilizzazioni(url: string, request: CriteriMensilizzazioniRequest): Observable<any> {
    console.log(request);
    let response = this.http.post<Blob>(ServicePathsSettings.DOMINIO_REPORT + url, request, {
      observe: 'response',
      responseType: 'blob' as 'json'
    })

    return response;
  }

  exportBilancio(url: string, request: CriteriBilancioRequest): Observable<any> {
    console.log(request);
    let response = this.http.post<Blob>(ServicePathsSettings.DOMINIO_REPORT + url, request, {
      observe: 'response',
      responseType: 'blob' as 'json'
    })

    return response;
  }

  exportPagamenti(url: string, request: CriteriPagamentiRequest): Observable<any> {
    console.log(request);
    let response = this.http.post<Blob>(ServicePathsSettings.DOMINIO_REPORT + url, request, {
      observe: 'response',
      responseType: 'blob' as 'json'
    })

    return response;
  }

  exportIncassi(url: string, request: CriteriIncassiRequest): Observable<any> {
    console.log(request);
    let response = this.http.post<Blob>(ServicePathsSettings.DOMINIO_REPORT + url, request, {
      observe: 'response',
      responseType: 'blob' as 'json'
    })

    return response;
  }

  exportFatture(url: string, request: CriteriFattureRequest): Observable<any> {
    console.log(request);
    let response = this.http.post<Blob>(ServicePathsSettings.DOMINIO_REPORT + url, request, {
      observe: 'response',
      responseType: 'blob' as 'json'
    })

    return response;
  }

  exportParcelle(url: string, request: CriteriParcelleRequest): Observable<any> {
    console.log(request);
    let response = this.http.post<Blob>(ServicePathsSettings.DOMINIO_REPORT + url, request, {
      observe: 'response',
      responseType: 'blob' as 'json'
    })

    return response;
  }

  exportIncarichi(url: string, request: CriteriIncarichiRequest): Observable<any> {
    console.log(request);
    let response = this.http.post(ServicePathsSettings.DOMINIO_REPORT + url, request, {
      observe: 'response',
      responseType: 'blob' as 'json'
    })

    return response;
  }

  exportPerformance(url: string, request: CriteriPerformanceRequest): Observable<any> {
    console.log(request);
    let response = this.http.post(ServicePathsSettings.DOMINIO_REPORT + url, request, {
      observe: 'response',
      responseType: 'blob' as 'json'
    })

    return response;
  }

  exportAccantonamenti(url: string, request: CriteriAccantonamentiRequest): Observable<any> {
    console.log(request);
    let response = this.http.post(ServicePathsSettings.DOMINIO_REPORT + url, request, {
      observe: 'response',
      responseType: 'blob' as 'json'
    })

    return response;
  }

  exportAdempimenti(url: string, request: CriteriAdempimentiRequest): Observable<any> {
    console.log(request);
    let response = this.http.post(ServicePathsSettings.DOMINIO_REPORT + url, request, {
      observe: 'response',
      responseType: 'blob' as 'json'
    })

    return response;
  }

  exportMod770(url: string): Observable<any> {
    let response = this.http.post(ServicePathsSettings.DOMINIO_REPORT + url, {}, {
      observe: 'response',
      responseType: 'blob' as 'json'
    })

    return response;
  }

  exportEstrazioneDati(url: string, request: EstrazioneDatiRequest): Observable<any> {
    return this.http.post(ServicePathsSettings.DOMINIO_REPORT + url, request, {
      observe: 'response',
      responseType: 'blob' as 'json'
    }).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 504) {
          console.log('Gateway Timeout (504)');
        }
        return throwError(() => error);
    }));
    // return throwError(() =>
    //   new HttpErrorResponse({
    //     status: 504,
    //     statusText: 'Gateway Timeout',
    //     error: { message: 'Simulazione 504' }
    //   })
    // );
  }

}

